import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import type React from "react";

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
  labelClassName?: string;
  containerClassName?: string;
  children?: React.ReactNode;
}

export function FormField({
  label,
  id,
  labelClassName,
  containerClassName,
  children,
  ...inputProps
}: FormFieldProps) {
  return (
    <div className={cn("grid gap-3", containerClassName)}>
      <div className="flex items-center">
        <Label htmlFor={id} className={labelClassName}>
          {label}
        </Label>
        {children}
      </div>
      <Input id={id} {...inputProps} />
    </div>
  );
}

export default FormField;
